import {LinkBuilder} from "../../../../../public/js/utils/LinkBuilder";
import {ControlsWelcomeLoginResetControl} from "../../../../controls/Modules/WelcomeModule/LoginPresenter/ResetControl/ResetControl";
import {ControlsWelcomeLoginLoginControl} from "../../../../controls/Modules/WelcomeModule/LoginPresenter/LoginControl/LoginControl";
import {PageLoader} from "../../../../../public/js/extras/PageLoader";

PageLoader.initializePresenterPage(true);

if (LinkBuilder.LinkBuilderController.getQueryParam('hash') !== null) {
    ControlsWelcomeLoginResetControl.Control.load();
} else {
    ControlsWelcomeLoginLoginControl.Control.load();
}


